export const LAMBDATEST_REQUEST_INFINITE_LOADING =
  "LAMBDATEST_REQUEST_INFINITE_LOADING";
export const LAMBDATEST_REQUEST_INFINITE_SUCCESS =
  "LAMBDATEST_REQUEST_INFINITE_SUCCESS";
export const LAMBDATEST_REQUEST_INFINITE_FAILED =
  "LAMBDATEST_REQUEST_INFINITE_FAILED";
export const LAMBDATEST_REQUEST_INFINITE_SILENT_LOADING =
  "LAMBDATEST_REQUEST_INFINITE_SILENT_LOADING";
export const LAMBDATEST_REQUEST_LOADING = "LAMBDATEST_REQUEST_LOADING";
export const LAMBDATEST_REQUEST_SUCCESS = "LAMBDATEST_REQUEST_SUCCESS";
export const LAMBDATEST_REQUEST_FAILED = "LAMBDATEST_REQUEST_FAILED";
export const LAMBDATEST_REQUEST_DATA_CLEAR = "LAMBDATEST_REQUEST_DATA_CLEAR";
export const FETCH_COMMAND_LOG_COUNT_SUCCESS =
  "FETCH_COMMAND_LOG_COUNT_SUCCESS";
export const FETCH_COMMAND_LOG_COUNT_FAILED = "FETCH_COMMAND_LOG_COUNT_FAILED";
export const LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_LOADING =
  "LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_LOADING";
export const LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_SUCCESS =
  "LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_SUCCESS";
export const LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_FAILED =
  "LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_FAILED";

export const LAMBDATEST_ADD_CDP_REQUEST_LOGS_SSE =
  "LAMBDATEST_ADD_CDP_REQUEST_LOGS_SSE";

export const LAMBDATEST_ALL_COMMAND = "LAMBDATEST_ALL_COMMAND";
export const LAMBDATEST_REPLACE_COMMAND_LOGS_SSE =
  "LAMBDATEST_REPLACE_COMMAND_LOGS_SSE";
export const LAMBDATEST_ADD_SANITIZED_COMMANDS =
  "LAMBDATEST_ADD_SANITIZED_COMMANDS";
export const LAMBDATEST_UPDATE_COMMAND_RERUN_EXECUTION_STATUS =
  "LAMBDATEST_UPDATE_COMMAND_RERUN_EXECUTION_STATUS";
export const SET_EXPANDED_ANNOTATIONS = "SET_EXPANDED_ANNOTATIONS";
export const SET_EXPANDED_COMMAND_LOGS = "SET_EXPANDED_COMMAND_LOGS";
